export default __webpack_public_path__ + "static/logo_blanco-010af88c299f3134d2ebe91309d1c848.png";